// extracted by mini-css-extract-plugin
module.exports = {"perk":"perk_perk__LKqI6","perkImg":"perk_perkImg__BCwAI","perkDescription":"perk_perkDescription__0Ktfw"};